<script>
	// The params prop contains values matched from the URL
	export let params = {};

	import { createEventDispatcher, onMount } from 'svelte';
	import { querystring, replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, 
		TextoFeedback,
		decodificarPayloadURL} from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let idDistribuicao;
	let aceiteOuRecusa, tituloProjeto, areaProjeto;
	
	onMount(async () => {
		let parametrosURL = new URLSearchParams($querystring);
		let payload = decodificarPayloadURL(parametrosURL.get('p'));
		
		const parametros = new URL('http://aval.cetreina?' + payload).searchParams;

		tituloProjeto = parametros.get('tp');
		areaProjeto = parametros.get('ap');
		aceiteOuRecusa = parametros.get('op');
		// console.log(aceiteOuRecusa);
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Executando ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			idDistribuicao = Number.parseInt(params.idDistribuicao);

			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('distribuicao/aceite-ou-recusa'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					idDistribuicao: idDistribuicao,
					acao: aceiteOuRecusa
				})
			}).catch(erros => {
				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});

				replace('/painel');
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}
	}
</script>

<TBox 
	titulo="Confirmação de {aceiteOuRecusa} da distribuição" 
	subtitulo="Informe os dados abaixo para prosseguir" 
	largura="8" 
	deslocamento="2" 
	icone="avaliacao">
	
	<p><strong>PROJETO</strong></p>
	<p>Titulo: {tituloProjeto}</p>
	<p class="mb-4">Área de atuação: {areaProjeto}</p>
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/distribuicao/listagem-aguardando-aceite" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-danger is-medium is-fullwidth">
						Executar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>